import './App.css';
import React, { useState, useEffect } from 'react';
import SiteRoutes from "./navigation"; 
import Layout from "./components/Layout";
import useAuth from "../src/Hooks/useAuth";
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import { Helmet } from 'react-helmet';

function App() {
  const authCtx = useAuth();
  const navigate = useNavigate();
  const [token,setToken] = useState(JSON.parse(localStorage.getItem('tokens')) ? JSON.parse(localStorage.getItem('tokens')) : null);

  const handleLogout = () => {
    authCtx.logout();
    navigate("/login", { replace: true });
  };

  useEffect(() => {
    const checkTokenExpiration = () => {
      if (token) {
        try {
          const decodedToken = jwtDecode(token);
          if (decodedToken.exp * 1000 < Date.now()) {
            handleLogout();
          }
        } catch (error) {
          console.error('Error decoding token:', error);
          handleLogout();
        }
      }
    };
    checkTokenExpiration();
  }, [token]);

  return (
    <>
      <Helmet>
        <title>TherapywithAI</title>
        <meta name="description" content="AI-powered therapy and mental wellness support." />
        <script type="text/javascript" src="https://api.goaffpro.com/loader.js?shop=fokiagrvsh"></script>
      </Helmet>
      <Layout>
        <SiteRoutes />
      </Layout>
    </>
  );
}
export default App;
